<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
  import BlueButton from "../BlueButton.svelte";

  import FormWithLabel from "../../molecules/FormWithLabel.svelte";
  import SectionBoard from "../../molecules/SectionBoard.svelte";
  import { initImageUploadValue } from "../../atoms/forms/ImageUpload";
  import { ErrorService } from "../../services/error.service";

  let loading = false;

  let defaultTitle = "";
  let serviceName = "";
  let logo = initImageUploadValue();

  const handleDefaultTitle = (event) => {
    defaultTitle = event.detail.value;
  };

  const handleServiceName = (event) => {
    serviceName = event.detail.value;
  };

  const handleLogo = (event) => {
    logo = event.detail.value;
  };

  onMount(async () => {
    const client = ApiService.createClient();
    const { data } = await client.get("/settings/defaultTitle");
    if (!data.defaultTitle) {
      return;
    }
    defaultTitle = data.defaultTitle;

    const serviceNameResponse = await client.get("/settings/serviceName");
    if (!serviceNameResponse.data.serviceName) {
      return;
    }
    serviceName = serviceNameResponse.data.serviceName;

    const logoResponse = await client.get("/settings/logo");
    logo.src = logoResponse.data.logo;
  });

  const saveDefaultTitle = async () => {
    const client = ApiService.createClient();
    loading = true;
    const promises = [
      client.post("/settings/defaultTitle", {
        value: defaultTitle,
      }),

      client.post("/settings/serviceName", {
        value: serviceName,
      }),
    ];
    if (logo.base64) {
      promises.push(
        client.post("/settings/logo", {
          base64: logo.base64,
        })
      );
    }

    try {
      await Promise.all(promises);
    } catch (e) {
      ErrorService.catch(e);
    } finally {
      loading = false;
    }
  };
</script>

<SectionBoard>
  <h2 class="font-semibold">サイトの設定</h2>

  <div class="mt-6">
    <FormWithLabel
      label="サービス名"
      input={handleServiceName}
      value={serviceName}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="ページタイトル"
      annotation="ページのデフォルトタイトルを指定します。"
      input={handleDefaultTitle}
      value={defaultTitle}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="ロゴ"
      input={handleLogo}
      file={logo}
      inputType="image"
    />
  </div>

  <BlueButton rounded klass="mt-4" click={saveDefaultTitle} {loading}>
    更新する
  </BlueButton>
</SectionBoard>
